import { ApiService, type ApiRequestConfig } from "./api.service";
import type { IWorkspaceMemberInvitation } from "@/types/workspace";

export class InvitationService extends ApiService {
  async fetchMyInvitations(config?: ApiRequestConfig): Promise<IWorkspaceMemberInvitation[]> {
    // Server-paginated (issue #1254); walk the pages so the pending-invites view
    // keeps the full set it renders locally. UI is unchanged.
    return this.getAllPages<IWorkspaceMemberInvitation>(
      ({ cursor, perPage }) => {
        const qs = new URLSearchParams({ per_page: String(perPage) });
        if (cursor) qs.set("cursor", cursor);
        return `/api/users/me/workspaces/invitations/?${qs}`;
      },
      undefined,
      config,
    );
  }

  async acceptInvitations(data: { invitations: string[] }): Promise<void> {
    return this.post(`/api/users/me/workspaces/invitations/`, data);
  }

  async getInvitationDetails(slug: string, id: string): Promise<IWorkspaceMemberInvitation> {
    return this.get(`/api/workspaces/${slug}/invitations/${id}/join/`);
  }

  async respondToInvitation(
    slug: string,
    id: string,
    data: { email: string; accepted: boolean },
  ): Promise<{ message: string }> {
    return this.post(`/api/workspaces/${slug}/invitations/${id}/join/`, data);
  }
}
